<template>

    <FormRow
        v-if="!readonly || valueData || forceShowWhenEmpty"
        :prop="prop"
        :showHighlight="showHighlight"
		:labelMinWidth="labelMinWidth"
        :title="title"
        :tooltipText="tooltipText"
		:tooltip-position="tooltipPosition"
        :isFocused="isFocusedData"
        :readonly="readonly"
		:isVertical="isVertical"
		:class="{'mb-3': !readonly && addBottomMargin}"
		:content-class="[$attrs.contentClass]"
        v-bind="attrsNoListeners"
        :disabled="disabled">

        <div>
<!--            <div :class="{'white-smoke': !readonly || !hideHighlight}">-->
<!--        <div class="white-smoke">-->

            <qw-input class=""
					  style="min-width: 150px;"
                      autocomplete="new-password"
                      v-model="valueData"
                      :inputDebounceDelay="inputDebounceDelay"
                      :readonly="readonly"
                      :type="wrapText || multiline ? 'textarea' : type"
                      :autosize="wrapText || multiline || minRows ? {minRows} : null"
                      :disabled="disabled"
                      :placeholder="placeholder"
                      :formatDataInProp="formatDataInProp"
                      :formatDataOutProp="formatDataOutProp"
					  :class="[textClass]"
                      v-bind="inputAttrsComputed"
                      @keydown.enter="onEnterPressed"
                      @focus="onFocus()"
                      @blur="onBlur()"/>
        </div>

        <!--		<template #tooltip>-->
        <!--			<slot name="tooltip"></slot>-->
        <!--		</template>-->
    </FormRow>

</template>

<script>

import BaseFormRow from "@/core/components/Form/Base/BaseFormRow.vue"
import FormRow from "@/core/components/Form/Base/FormRow.vue";
import QwInput from "@/core/components/Controls/QwInput.vue";

export default {
    name: "FormTextRow",
    components: {QwInput, FormRow},
    extends: BaseFormRow,
    props: {
		showHighlight: Boolean,
        type: String,
		labelMinWidth: Number,
		forceShowWhenEmpty: Boolean,
        multiline: {Boolean, default: false},
        preventEnterKey: {Boolean, default: false},
        wrapText: {Boolean, default: false},
        minRows: Number,
        textClass: String,
		tooltipPosition: String,
        inputAttrs: {Object, default: () => ({})},
        inputDebounceDelay: Number,
        disabled: Boolean,
		addBottomMargin: {Boolean, default: true},
		isVertical: Boolean,
    },
    methods: {
        onEnterPressed(event) {
            if (this.preventEnterKey || this.wrapText) {
                event.preventDefault()
            }
        },

        focus() {
			let input = this.$el.getElementsByTagName("textarea")[0]
			if(!input){
				input = this.$el.getElementsByTagName("input")[0]
			}
            input.focus()
        },

		insertTextAtCursor(text){
			let textArea = this.$el.getElementsByTagName("textarea")[0]
			if(!textArea){
				textArea = this.$el.getElementsByTagName("input")[0]
			}
			let caretPos = textArea.selectionStart;
			let textAreaTxt = textArea.value;
			this.valueData = textAreaTxt.substring(0, caretPos) + text + textAreaTxt.substring(caretPos)
			this.notifyValueChanged()
		}
    },

    computed: {
        inputAttrsComputed() {
            return {
                ...this.$attrs,
                ...this.inputAttrs
            }
        }
    }
}
</script>

<style>
.bold2 {
    font-weight: 600;
}

</style>
